import { render, staticRenderFns } from "./ActivityFormSidebar.vue?vue&type=template&id=973ea822&scoped=true"
import script from "./ActivityFormSidebar.vue?vue&type=script&lang=js"
export * from "./ActivityFormSidebar.vue?vue&type=script&lang=js"
import style0 from "./ActivityFormSidebar.vue?vue&type=style&index=0&id=973ea822&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "973ea822",
  null
  
)

export default component.exports